// extracted by mini-css-extract-plugin
export default {"container":"NavigationButtons_container__tmyQa","floatingPlate":"NavigationButtons_floatingPlate__PNmVa"};